export function getSubdomain(): string {
  const { hostname } = window.location;

  let subdomain = hostname;

  if (hostname !== 'localhost') {
    const parts = hostname.split('.');
    [subdomain] = parts;
  }

  return subdomain;
}
